<template>

  <section class="dp-layout">

    <section class="dp-left">

      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>

    </section>

    <section class="dp-right">

      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <p class="dp-dept-hint">
        <span class="dp-dept-hint__label">当前学校</span>
        <span class="dp-dept-hint__value">{{ departmentName || '未选择' }}</span>
      </p>



      <div class="tbl-scroll-host">
      <el-table :data="list" v-loading="loading" class="compact-table" style="width: 100%;" height="100%">

        <el-table-column prop="SerialNo" label="卡号" min-width="180" show-overflow-tooltip />

        <el-table-column prop="PointsValue" label="分值" width="80" align="center" />

        <el-table-column prop="BatchNo" label="批次" min-width="120" show-overflow-tooltip />

        <el-table-column prop="Status" label="状态" width="90" align="center">

          <template slot-scope="scope">

            <el-tag :type="scope.row.Status === 0 ? 'success' : (scope.row.Status === 1 ? 'warning' : 'danger')">

              {{ statusName(scope.row.Status) }}

            </el-tag>

          </template>

        </el-table-column>

        <el-table-column prop="Enabled" label="启用" width="80" align="center">

          <template slot-scope="scope">

            <el-tag :type="scope.row.Enabled ? 'success' : 'danger'">{{ scope.row.Enabled ? '是' : '否' }}</el-tag>

          </template>

        </el-table-column>

        <el-table-column label="回收" width="70" align="center">

          <template slot-scope="scope">

            <el-button v-if="scope.row.RecycleCount > 0" type="text" size="small" class="batch-action-link"
              @click="openCardRecycleDetail(scope.row)">{{ scope.row.RecycleCount }}</el-button>

            <span v-else>0</span>

          </template>

        </el-table-column>

        <el-table-column label="操作" width="168" align="center">

          <template slot-scope="scope">

            <div class="table-op-stacked">

              <div class="op-grid">

                <el-button size="mini" class="op-solid-btn" @click="openUpdatePoints(scope.row)">改分值</el-button>

                <el-button size="mini"
                  :class="['op-solid-btn', scope.row.Enabled ? 'op-danger-btn' : 'op-success-btn']"
                  @click="toggleEnable(scope.row)">

                  {{ scope.row.Enabled ? '停用' : '启用' }}

                </el-button>

              </div>

              <div class="op-grid op-grid-single">

                <el-button size="mini" class="op-solid-btn op-danger-btn" @click="recycle(scope.row)"
                  :disabled="scope.row.Status !== 1">回收</el-button>

              </div>

            </div>

          </template>

        </el-table-column>

      </el-table>
      </div>



      <div class="pagination-container">

        <el-pagination layout="total, prev, pager, next" :current-page="page" :page-size="pageSize" :total="total"
          @current-change="onPageChange" />

      </div>



      <!-- 批次管理弹窗 -->

      <el-dialog  title="德育分卡批次管理" :visible.sync="batchVisible" width="920px" top="6vh" :close-on-click-modal="false"
        @open="onBatchDialogOpen">

        <div class="batch-toolbar">

          <el-input v-model="batchKeyword" placeholder="批次号关键字" clearable size="small" style="width: 220px;"
            @keyup.enter.native="loadBatchList" />

          <el-button size="small" @click="loadBatchList">查询</el-button>

          <el-button type="primary" size="small" @click="openGenerate">新增批次</el-button>

        </div>

        <el-table :data="batchList" v-loading="batchLoading" class="compact-table batch-dialog-table"
          style="width: 100%; margin-top: 12px;" max-height="420">

          <el-table-column prop="BatchNo" label="批次号" width="180" show-overflow-tooltip />

          <el-table-column label="生成时间" width="170">

            <template slot-scope="scope">{{ formatDateTime(scope.row.CreateTime) }}</template>

          </el-table-column>

          <el-table-column prop="CardCount" label="卡片数" width="" align="center" />

          <el-table-column prop="PointsValue" label="分值" width="" align="center" />

          <el-table-column label="状态分布" width="">

            <template slot-scope="scope">

              <span class="batch-stat">可用 {{ scope.row.ActiveCount || 0 }}</span>

              <span class="batch-stat">已核销 {{ scope.row.RedeemedCount || 0 }}</span>

              <span class="batch-stat">作废 {{ scope.row.VoidedCount || 0 }}</span>

            </template>

          </el-table-column>

          <el-table-column label="回收次数" width="88" align="center">

            <template slot-scope="scope">

              <el-button v-if="(scope.row.RecycleCount || 0) > 0" type="text" size="small" class="batch-action-link"
                @click="openBatchRecycleSummary(scope.row)">{{ scope.row.RecycleCount || 0 }}</el-button>

              <span v-else class="recycle-count-zero">0</span>

            </template>

          </el-table-column>

          <el-table-column label="操作" width="" align="center">

            <template slot-scope="scope">

              <div class="batch-op-row">

                <el-button type="text" size="small" class="batch-action-link" @click="openBrowseBatch(scope.row)">浏览</el-button>

                <span class="batch-action-divider">|</span>

                <el-button type="text" size="small" class="batch-action-link"
                  :loading="exportingBatchNo === scope.row.BatchNo" @click="exportBatch(scope.row)">导出</el-button>

              </div>

            </template>

          </el-table-column>

        </el-table>

        <div class="pagination-container">

          <el-pagination layout="total, prev, pager, next" :current-page="batchPage" :page-size="batchPageSize"
            :total="batchTotal" @current-change="onBatchPageChange" />

        </div>

      </el-dialog>



      <!-- 批次卡号浏览弹窗 -->

      <el-dialog  :title="browseTitle" :visible.sync="browseVisible" width="860px" append-to-body
        :close-on-click-modal="false" @open="loadBrowseList">

        <el-table :data="browseList" v-loading="browseLoading" class="compact-table batch-dialog-table" style="width: 100%;"
          max-height="460">

          <el-table-column type="index" label="序号" width="60" align="center" :index="browseIndexMethod" />

          <el-table-column prop="SerialNo" label="卡号" min-width="180" show-overflow-tooltip />

          <el-table-column prop="QrContent" label="二维码内容" min-width="240" show-overflow-tooltip />

          <el-table-column prop="PointsValue" label="分值" width="88" align="center" />

          <el-table-column prop="Status" label="状态" width="90" align="center">

            <template slot-scope="scope">

              <el-tag :type="scope.row.Status === 0 ? 'success' : (scope.row.Status === 1 ? 'warning' : 'danger')"
                size="mini">

                {{ statusName(scope.row.Status) }}

              </el-tag>

            </template>

          </el-table-column>

          <el-table-column prop="Enabled" label="启用" width="70" align="center">

            <template slot-scope="scope">

              <el-tag :type="scope.row.Enabled ? 'success' : 'danger'" size="mini">{{ scope.row.Enabled ? '是' : '否'
              }}</el-tag>

            </template>

          </el-table-column>

        </el-table>

        <div class="pagination-container">

          <el-pagination layout="total, prev, pager, next" :current-page="browsePage" :page-size="browsePageSize"
            :total="browseTotal" @current-change="onBrowsePageChange" />

        </div>

      </el-dialog>



      <!-- 回收记录弹窗（全校） -->

      <el-dialog  title="德育分卡回收记录" :visible.sync="recycleRecordVisible" width="960px" top="6vh"
        :close-on-click-modal="false" @open="onRecycleRecordDialogOpen">

        <div class="batch-toolbar">

          <el-input v-model="recycleFilters.serialKeyword" placeholder="卡号关键字" clearable size="small"
            style="width: 160px;" @keyup.enter.native="loadRecycleRecordList" />

          <el-input v-model="recycleFilters.batchNo" placeholder="批次号" clearable size="small" style="width: 160px;"
            @keyup.enter.native="loadRecycleRecordList" />

          <el-date-picker v-model="recycleFilters.dateRange" type="daterange" size="small" value-format="yyyy-MM-dd"
            start-placeholder="开始日期" end-placeholder="结束日期" style="width: 240px;" />

          <el-button size="small" @click="loadRecycleRecordList">查询</el-button>

          <el-button size="small" type="warning" plain :loading="exportingRecycleLogs"
            @click="exportRecycleRecords">导出</el-button>

        </div>

        <div class="recycle-record-stat">共回收 <strong>{{ recycleRecordTotal }}</strong> 次</div>

        <el-table :data="recycleRecordList" v-loading="recycleRecordLoading" class="compact-table batch-dialog-table"
          style="width: 100%; margin-top: 8px;" max-height="420">

          <el-table-column label="回收时间" width="170">

            <template slot-scope="scope">{{ formatDateTime(scope.row.CreateTime) }}</template>

          </el-table-column>

          <el-table-column prop="SerialNo" label="卡号" min-width="180" show-overflow-tooltip />

          <el-table-column prop="BatchNo" label="批次号" min-width="140" show-overflow-tooltip />

          <el-table-column prop="PointsValue" label="分值" width="72" align="center" />

          <el-table-column prop="Operator" label="操作人" width="120" show-overflow-tooltip />

          <el-table-column prop="Remark" label="备注" min-width="120" show-overflow-tooltip />

        </el-table>

        <div class="pagination-container">

          <el-pagination layout="total, prev, pager, next" :current-page="recycleRecordPage"
            :page-size="recycleRecordPageSize" :total="recycleRecordTotal" @current-change="onRecycleRecordPageChange" />

        </div>

      </el-dialog>



      <!-- 批次回收汇总（按卡） -->

      <el-dialog  :title="batchRecycleSummaryTitle" :visible.sync="batchRecycleSummaryVisible" width="820px"
        append-to-body :close-on-click-modal="false" @open="loadBatchRecycleSummary">

        <div class="batch-toolbar">

          <el-input v-model="batchRecycleKeyword" placeholder="卡号关键字" clearable size="small" style="width: 220px;"
            @keyup.enter.native="loadBatchRecycleSummary" />

          <el-button size="small" @click="loadBatchRecycleSummary">查询</el-button>

        </div>

        <el-table :data="batchRecycleList" v-loading="batchRecycleLoading" class="compact-table batch-dialog-table"
          style="width: 100%; margin-top: 8px;" max-height="420">

          <el-table-column prop="SerialNo" label="卡号" min-width="180" show-overflow-tooltip />

          <el-table-column prop="PointsValue" label="分值" width="72" align="center" />

          <el-table-column label="回收次数" width="88" align="center">

            <template slot-scope="scope">

              <el-button type="text" size="small" class="batch-action-link"
                @click="openCardRecycleDetail(scope.row)">{{ scope.row.RecycleCount }}</el-button>

            </template>

          </el-table-column>

          <el-table-column label="最近回收" width="170">

            <template slot-scope="scope">{{ formatDateTime(scope.row.LastRecycleTime) }}</template>

          </el-table-column>

          <el-table-column label="操作" width="100" align="center">

            <template slot-scope="scope">

              <el-button type="text" size="small" class="batch-action-link"
                @click="openCardRecycleDetail(scope.row)">明细</el-button>

            </template>

          </el-table-column>

        </el-table>

        <div class="pagination-container">

          <el-pagination layout="total, prev, pager, next" :current-page="batchRecyclePage"
            :page-size="batchRecyclePageSize" :total="batchRecycleTotal" @current-change="onBatchRecyclePageChange" />

        </div>

      </el-dialog>



      <!-- 单卡回收明细 -->

      <el-dialog :title="cardRecycleDetailTitle" :visible.sync="cardRecycleDetailVisible" width="760px" append-to-body
        :close-on-click-modal="false" @open="loadCardRecycleDetail">

        <el-table :data="cardRecycleDetailList" v-loading="cardRecycleDetailLoading" class="compact-table batch-dialog-table"
          style="width: 100%;" max-height="420">

          <el-table-column type="index" label="序号" width="60" align="center"
            :index="cardRecycleDetailIndexMethod" />

          <el-table-column label="回收时间" width="170">

            <template slot-scope="scope">{{ formatDateTime(scope.row.CreateTime) }}</template>

          </el-table-column>

          <el-table-column prop="PointsValue" label="分值" width="72" align="center" />

          <el-table-column prop="Operator" label="操作人" width="120" show-overflow-tooltip />

          <el-table-column prop="Remark" label="备注" min-width="120" show-overflow-tooltip />

        </el-table>

        <div class="pagination-container">

          <el-pagination layout="total, prev, pager, next" :current-page="cardRecycleDetailPage"
            :page-size="cardRecycleDetailPageSize" :total="cardRecycleDetailTotal"
            @current-change="onCardRecycleDetailPageChange" />

        </div>

      </el-dialog>



      <!-- 新增批次弹窗 -->

      <el-dialog title="新增批次" :visible.sync="generateVisible" width="520px" append-to-body :close-on-click-modal="false"
        @open="onGenerateDialogOpen">

        <el-form :model="generateForm" label-width="110px">

          <el-form-item label="生成数量"><el-input-number v-model="generateForm.Count" :min="1"
              :max="2000" /></el-form-item>

          <el-form-item label="卡片分值"><el-input-number v-model="generateForm.PointsValue" :min="0.01"
              :precision="2" /></el-form-item>

          <el-form-item label="批次号">

            <el-input v-model="generateForm.BatchNoPreview" disabled placeholder="系统自动生成" />

            <div class="form-tip">批次号由系统自动生成，提交后以实际落库为准</div>

          </el-form-item>

        </el-form>

        <span slot="footer">

          <el-button @click="generateVisible = false">取消</el-button>

          <el-button type="primary" :loading="submitLoading" @click="submitGenerate">生成</el-button>

        </span>

      </el-dialog>



      <el-dialog title="修改卡片分值" :visible.sync="pointsVisible" width="420px" :close-on-click-modal="false">

        <el-form :model="pointsForm" label-width="90px">

          <el-form-item label="新分值"><el-input-number v-model="pointsForm.PointsValue" :min="0.01"
              :precision="2" /></el-form-item>

        </el-form>

        <span slot="footer">

          <el-button @click="pointsVisible = false">取消</el-button>

          <el-button type="primary" :loading="submitLoading" @click="submitUpdatePoints">保存</el-button>

        </span>

      </el-dialog>

    </section>

  </section>

</template>



<script>

import DepartmentPane from '@/components/DepartmentPane.vue'

import Toolbar from '../../components/Toolbar'

import { getButtonList } from '../../promissionRouter'

import { listMoralPointCards, generateMoralPointCards, previewMoralPointCardBatchNo, listMoralPointCardBatches, exportMoralPointCardBatch, recycleMoralPointCard, enableMoralPointCard, updateMoralPointCardPoints, listMoralPointCardRecycleLogs, exportMoralPointCardRecycleLogs, listMoralPointCardBatchRecycleSummary } from '../../api/modules/moral-education';
import { treeNodeDeptId } from '../../utils/deptCascaderProps';
export default {

  name: 'MoralPointCardManage',

  components: { DepartmentPane, Toolbar },

  data() {

    return {

      departmentId: 0,

      departmentName: '',

      filters: { status: null, batchNo: '', serialKeyword: '' },

      searchList: [

        { label: '卡号关键字', key: 'serialKeyword' },

        { label: '批次号', key: 'batchNo' },

        {

          label: '状态',

          key: 'status',

          type: 'select',

          clearable: true,

          options: [

            { label: '可用', value: 0 },

            { label: '已核销', value: 1 },

            { label: '作废', value: 2 }

          ]

        }

      ],

      buttonList: [],

      loading: false,

      list: [],

      page: 1,

      pageSize: 10,

      total: 0,

      batchVisible: false,

      batchLoading: false,

      batchList: [],

      batchPage: 1,

      batchPageSize: 10,

      batchTotal: 0,

      batchKeyword: '',

      exportingBatchNo: '',

      browseVisible: false,

      browseBatchNo: '',

      browseList: [],

      browseLoading: false,

      browsePage: 1,

      browsePageSize: 10,

      browseTotal: 0,

      generateVisible: false,

      pointsVisible: false,

      submitLoading: false,

      generateForm: { Count: 10, PointsValue: 1, BatchNoPreview: '' },

      pointsForm: { CardId: 0, PointsValue: 1 },

      recycleRecordVisible: false,

      recycleRecordLoading: false,

      recycleRecordList: [],

      recycleRecordPage: 1,

      recycleRecordPageSize: 10,

      recycleRecordTotal: 0,

      recycleFilters: { serialKeyword: '', batchNo: '', dateRange: [] },

      exportingRecycleLogs: false,

      batchRecycleSummaryVisible: false,

      batchRecycleBatchNo: '',

      batchRecycleKeyword: '',

      batchRecycleList: [],

      batchRecycleLoading: false,

      batchRecyclePage: 1,

      batchRecyclePageSize: 10,

      batchRecycleTotal: 0,

      cardRecycleDetailVisible: false,

      cardRecycleDetailCardId: 0,

      cardRecycleDetailSerialNo: '',

      cardRecycleDetailList: [],

      cardRecycleDetailLoading: false,

      cardRecycleDetailPage: 1,

      cardRecycleDetailPageSize: 10,

      cardRecycleDetailTotal: 0

    }

  },

  computed: {

    browseTitle() {

      return this.browseBatchNo ? `批次卡号浏览 - ${this.browseBatchNo}` : '批次卡号浏览'

    },

    batchRecycleSummaryTitle() {

      return this.batchRecycleBatchNo ? `批次回收汇总 - ${this.batchRecycleBatchNo}` : '批次回收汇总'

    },

    cardRecycleDetailTitle() {

      return this.cardRecycleDetailSerialNo ? `回收明细 - ${this.cardRecycleDetailSerialNo}` : '回收明细'

    }

  },

  methods: {

    callFunction(item) {

      if (typeof item.search === 'object') {

        this.filters = Object.assign({}, this.filters, item.search || {})

      }

      this[item.Func].apply(this, item)

    },

    handleQuery() {

      this.page = 1

      this.loadList()

    },

    handleBatchManage() {

      if (this.departmentId <= 0) return this.$message.warning('请先在左侧选择学校')

      this.batchVisible = true

    },

    handleRecycleRecords() {

      if (this.departmentId <= 0) return this.$message.warning('请先在左侧选择学校')

      this.recycleRecordVisible = true

    },

    onRecycleRecordDialogOpen() {

      this.recycleRecordPage = 1

      this.loadRecycleRecordList()

    },

    onRecycleRecordPageChange(p) {

      this.recycleRecordPage = p

      this.loadRecycleRecordList()

    },

    buildRecycleRecordQuery() {

      const dateRange = this.recycleFilters.dateRange || []

      return {

        departmentId: this.departmentId,

        page: this.recycleRecordPage,

        pageSize: this.recycleRecordPageSize,

        serialKeyword: this.recycleFilters.serialKeyword || undefined,

        batchNo: this.recycleFilters.batchNo || undefined,

        dateFrom: dateRange[0] || undefined,

        dateTo: dateRange[1] || undefined

      }

    },

    async loadRecycleRecordList() {

      if (this.departmentId <= 0) return

      this.recycleRecordLoading = true

      try {

        const res = await listMoralPointCardRecycleLogs(this.buildRecycleRecordQuery())

        if (res.data.success) {

          const pm = res.data.response || {}

          this.recycleRecordList = pm.data || []

          this.recycleRecordTotal = pm.dataCount || 0

        } else {

          this.$message.error(res.data.msg || '回收记录查询失败')

        }

      } finally {

        this.recycleRecordLoading = false

      }

    },

    async exportRecycleRecords() {

      if (this.departmentId <= 0) return this.$message.warning('请先在左侧选择学校')

      this.exportingRecycleLogs = true

      try {

        const response = await exportMoralPointCardRecycleLogs(this.buildRecycleRecordQuery())

        if (!response || typeof response.status !== 'number' || !response.config) {

          const msg = (response && (response.msg || response.message)) || '导出失败'

          this.$message.error(msg)

          return

        }

        const contentType = (response.headers && (response.headers['content-type'] || response.headers['Content-Type'])) || ''

        if (contentType.includes('application/json') || contentType.includes('text/plain')) {

          const msg = await this.parseBlobJsonMsg(response.data)

          this.$message.warning(msg || '无回收记录可导出')

          return

        }

        if (!response.data || (response.data.size != null && response.data.size === 0)) {

          this.$message.warning('无回收记录可导出')

          return

        }

        const blob = new Blob([response.data], {

          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

        })

        const url = URL.createObjectURL(blob)

        const link = document.createElement('a')

        link.href = url

        link.setAttribute('download', `德育分卡回收记录_${Date.now()}.xlsx`)

        document.body.appendChild(link)

        link.click()

        document.body.removeChild(link)

        URL.revokeObjectURL(url)

        this.$message.success('导出成功')

      } catch (error) {

        const blob = error.response && error.response.data

        if (blob instanceof Blob) {

          const msg = await this.parseBlobJsonMsg(blob)

          this.$message.warning(msg || '导出失败')

          return

        }

        this.$message.error('导出失败')

      } finally {

        this.exportingRecycleLogs = false

      }

    },

    openBatchRecycleSummary(row) {

      const batchNo = row && row.BatchNo

      if (!batchNo) return this.$message.warning('批次号无效')

      if (!(row.RecycleCount > 0)) return

      this.batchRecycleBatchNo = batchNo

      this.batchRecycleKeyword = ''

      this.batchRecyclePage = 1

      this.batchRecycleList = []

      this.batchRecycleTotal = 0

      this.batchRecycleSummaryVisible = true

    },

    onBatchRecyclePageChange(p) {

      this.batchRecyclePage = p

      this.loadBatchRecycleSummary()

    },

    async loadBatchRecycleSummary() {

      if (this.departmentId <= 0 || !this.batchRecycleBatchNo) return

      this.batchRecycleLoading = true

      try {

        const res = await listMoralPointCardBatchRecycleSummary({

          departmentId: this.departmentId,

          batchNo: this.batchRecycleBatchNo,

          page: this.batchRecyclePage,

          pageSize: this.batchRecyclePageSize,

          serialKeyword: this.batchRecycleKeyword || undefined

        })

        if (res.data.success) {

          const pm = res.data.response || {}

          this.batchRecycleList = pm.data || []

          this.batchRecycleTotal = pm.dataCount || 0

        } else {

          this.$message.error(res.data.msg || '批次回收汇总查询失败')

        }

      } finally {

        this.batchRecycleLoading = false

      }

    },

    openCardRecycleDetail(row) {

      const cardId = Number(row && (row.CardId || row.Id) || 0)

      const serialNo = (row && row.SerialNo) || ''

      if (cardId <= 0) return this.$message.warning('卡号无效')

      if (!(row.RecycleCount > 0)) return

      this.cardRecycleDetailCardId = cardId

      this.cardRecycleDetailSerialNo = serialNo

      this.cardRecycleDetailPage = 1

      this.cardRecycleDetailList = []

      this.cardRecycleDetailTotal = 0

      this.cardRecycleDetailVisible = true

    },

    cardRecycleDetailIndexMethod(index) {

      return (this.cardRecycleDetailPage - 1) * this.cardRecycleDetailPageSize + index + 1

    },

    onCardRecycleDetailPageChange(p) {

      this.cardRecycleDetailPage = p

      this.loadCardRecycleDetail()

    },

    async loadCardRecycleDetail() {

      if (this.departmentId <= 0 || this.cardRecycleDetailCardId <= 0) return

      this.cardRecycleDetailLoading = true

      try {

        const res = await listMoralPointCardRecycleLogs({

          departmentId: this.departmentId,

          cardId: this.cardRecycleDetailCardId,

          page: this.cardRecycleDetailPage,

          pageSize: this.cardRecycleDetailPageSize

        })

        if (res.data.success) {

          const pm = res.data.response || {}

          this.cardRecycleDetailList = pm.data || []

          this.cardRecycleDetailTotal = pm.dataCount || 0

        } else {

          this.$message.error(res.data.msg || '回收明细查询失败')

        }

      } finally {

        this.cardRecycleDetailLoading = false

      }

    },

    statusName(status) {

      if (status === 0) return '可用'

      if (status === 1) return '已核销'

      if (status === 2) return '作废'

      return '-'

    },

    formatDateTime(value) {

      if (!value) return '-'

      const d = new Date(value)

      if (Number.isNaN(d.getTime())) return String(value)

      const pad = n => (n < 10 ? '0' + n : '' + n)

      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`

    },

    buildQuery() {

      return {

        teacherId: 0,

        departmentId: this.departmentId,

        page: this.page,

        pageSize: this.pageSize,

        status: this.filters.status,

        batchNo: this.filters.batchNo,

        serialKeyword: this.filters.serialKeyword

      }

    },

    buildBatchQuery() {

      return {

        departmentId: this.departmentId,

        page: this.batchPage,

        pageSize: this.batchPageSize,

        batchKeyword: this.batchKeyword || undefined

      }

    },

    async loadList() {

      if (this.departmentId <= 0) return this.$message.warning('请先在左侧选择学校')

      this.loading = true

      try {

        const res = await listMoralPointCards(this.buildQuery())

        if (res.data.success) {

          const pm = res.data.response || {}

          this.list = pm.data || []

          this.total = pm.dataCount || 0

        } else this.$message.error(res.data.msg || '查询失败')

      } finally {

        this.loading = false

      }

    },

    onPageChange(p) {

      this.page = p

      this.loadList()

    },

    onBatchDialogOpen() {

      this.batchPage = 1

      this.loadBatchList()

    },

    onBatchPageChange(p) {

      this.batchPage = p

      this.loadBatchList()

    },

    openBrowseBatch(row) {

      const batchNo = row && row.BatchNo

      if (!batchNo) return this.$message.warning('批次号无效')

      this.browseBatchNo = batchNo

      this.browsePage = 1

      this.browseList = []

      this.browseTotal = 0

      this.browseVisible = true

    },

    browseIndexMethod(index) {

      return (this.browsePage - 1) * this.browsePageSize + index + 1

    },

    onBrowsePageChange(p) {

      this.browsePage = p

      this.loadBrowseList()

    },

    async loadBrowseList() {

      if (this.departmentId <= 0 || !this.browseBatchNo) return

      this.browseLoading = true

      try {

        const res = await listMoralPointCards({

          teacherId: 0,

          departmentId: this.departmentId,

          page: this.browsePage,

          pageSize: this.browsePageSize,

          batchNo: this.browseBatchNo

        })

        if (res.data.success) {

          const pm = res.data.response || {}

          this.browseList = pm.data || []

          this.browseTotal = pm.dataCount || 0

        } else {

          this.$message.error(res.data.msg || '加载批次卡号失败')

        }

      } finally {

        this.browseLoading = false

      }

    },

    async loadBatchList() {

      if (this.departmentId <= 0) return

      this.batchLoading = true

      try {

        const res = await listMoralPointCardBatches(this.buildBatchQuery())

        if (res.data.success) {

          const pm = res.data.response || {}

          this.batchList = pm.data || []

          this.batchTotal = pm.dataCount || 0

        } else {

          this.$message.error(res.data.msg || '批次查询失败')

        }

      } finally {

        this.batchLoading = false

      }

    },

    async onGenerateDialogOpen() {

      this.generateForm = { Count: 10, PointsValue: 1, BatchNoPreview: '' }

      try {

        const res = await previewMoralPointCardBatchNo()

        if (res.data.success) {

          this.generateForm.BatchNoPreview = res.data.response || ''

        }

      } catch (e) {

        // 预览失败不阻断生成

      }

    },

    openGenerate() {

      this.generateVisible = true

    },

    async submitGenerate() {

      if (this.departmentId <= 0) return this.$message.warning('请先在左侧选择学校')

      this.submitLoading = true

      try {

        const res = await generateMoralPointCards({

          TeacherId: 0,

          DepartmentId: this.departmentId,

          Count: this.generateForm.Count,

          PointsValue: this.generateForm.PointsValue

        })

        if (res.data.success) {

          this.$message.success(res.data.msg || '生成成功')

          this.generateVisible = false

          this.loadBatchList()

          this.loadList()

        } else {

          this.$message.error(res.data.msg || '生成失败')

        }

      } finally {

        this.submitLoading = false

      }

    },

    async parseBlobJsonMsg(blob) {

      if (!(blob instanceof Blob)) return null

      try {

        const head = await blob.slice(0, 4).arrayBuffer()

        const u8 = new Uint8Array(head)

        if (u8.length >= 2 && u8[0] === 0x50 && u8[1] === 0x4b) return null

        const text = await new Promise((resolve, reject) => {

          const reader = new FileReader()

          reader.onload = () => resolve(reader.result)

          reader.onerror = reject

          reader.readAsText(blob)

        })

        const trimmed = (text || '').trim()

        if (!trimmed) return null

        try {

          const j = JSON.parse(trimmed)

          return j.msg || j.message || null

        } catch (e) {

          return trimmed.length <= 2000 ? trimmed : null

        }

      } catch (e) {

        return null

      }

    },

    async exportBatch(row) {

      if (this.departmentId <= 0) return this.$message.warning('请先在左侧选择学校')

      const batchNo = row && row.BatchNo

      if (!batchNo) return this.$message.warning('批次号无效')

      this.exportingBatchNo = batchNo

      try {

        const response = await exportMoralPointCardBatch({

          departmentId: this.departmentId,

          batchNo: batchNo

        })

        if (!response || typeof response.status !== 'number' || !response.config) {

          const msg = (response && (response.msg || response.message)) || '导出失败'

          this.$message.error(msg)

          return

        }

        const contentType = (response.headers && (response.headers['content-type'] || response.headers['Content-Type'])) || ''

        if (contentType.includes('application/json') || contentType.includes('text/plain')) {

          const msg = await this.parseBlobJsonMsg(response.data)

          this.$message.warning(msg || '该批次无数据可导出')

          return

        }

        if (!response.data || (response.data.size != null && response.data.size === 0)) {

          this.$message.warning('该批次无数据可导出')

          return

        }

        const blob = new Blob([response.data], {

          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

        })

        const url = URL.createObjectURL(blob)

        const link = document.createElement('a')

        link.href = url

        link.setAttribute('download', `德育分卡批次_${batchNo}.xlsx`)

        document.body.appendChild(link)

        link.click()

        document.body.removeChild(link)

        URL.revokeObjectURL(url)

        this.$message.success('导出成功')

      } catch (error) {

        const blob = error.response && error.response.data

        if (blob instanceof Blob) {

          const msg = await this.parseBlobJsonMsg(blob)

          this.$message.warning(msg || '导出失败')

          return

        }

        this.$message.error('导出失败')

      } finally {

        this.exportingBatchNo = ''

      }

    },

    async toggleEnable(row) {

      if (this.departmentId <= 0) return this.$message.warning('请先在左侧选择学校')

      const enabling = !row.Enabled

      if (!enabling) {
        try {
          await this.$confirm(`确认停用卡号「${row.SerialNo || ''}」吗？`, '提示', {
            type: 'warning',
            confirmButtonText: '确认停用',
            cancelButtonText: '取消',
            confirmButtonClass: 'el-button--danger',
          })
        } catch (e) {
          return
        }
      }

      const res = await enableMoralPointCard({ TeacherId: 0, CardId: row.Id, Enabled: enabling, DepartmentId: this.departmentId })

      if (res.data.success) {

        this.$message.success(res.data.msg || '操作成功')

        this.loadList()

      } else this.$message.error(res.data.msg || '操作失败')

    },

    async recycle(row) {

      if (this.departmentId <= 0) return this.$message.warning('请先在左侧选择学校')

      const res = await recycleMoralPointCard({ TeacherId: 0, CardId: row.Id, Remark: '后台回收', DepartmentId: this.departmentId })

      if (res.data.success) {

        this.$message.success(res.data.msg || '回收成功')

        this.loadList()

      } else this.$message.error(res.data.msg || '回收失败')

    },

    openUpdatePoints(row) {

      this.pointsForm = { CardId: row.Id, PointsValue: Number(row.PointsValue || 1) }

      this.pointsVisible = true

    },

    async submitUpdatePoints() {

      if (this.departmentId <= 0) return this.$message.warning('请先在左侧选择学校')

      this.submitLoading = true

      try {

        const res = await updateMoralPointCardPoints({

          TeacherId: 0,

          CardId: this.pointsForm.CardId,

          PointsValue: this.pointsForm.PointsValue,

          DepartmentId: this.departmentId

        })

        if (res.data.success) {

          this.$message.success(res.data.msg || '保存成功')

          this.pointsVisible = false

          this.loadList()

        } else this.$message.error(res.data.msg || '保存失败')

      } finally {

        this.submitLoading = false

      }

    },

    treeNodeClick(data) {

      this.departmentId = treeNodeDeptId(data)

      this.departmentName = (data && (data.label || data.Name || data.name)) || ''

      this.page = 1

      this.list = []

      this.total = 0

      this.batchPage = 1

      this.batchList = []

      this.batchTotal = 0

      if (this.departmentId > 0) {

        this.loadList()

      }

    }

  },

  mounted() {

    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : []

    this.buttonList = getButtonList(this.$route.path, routers)

    if (!this.buttonList.some(b => b.Func === 'handleQuery')) {

      this.buttonList.unshift({ name: '查询', Func: 'handleQuery', id: 999 })

    }

    if (!this.buttonList.some(b => b.Func === 'handleRecycleRecords')) {

      const batchIdx = this.buttonList.findIndex(b => b.Func === 'handleBatchManage')

      const recycleBtn = { name: '回收记录', Func: 'handleRecycleRecords', id: 998 }

      if (batchIdx >= 0) {

        this.buttonList.splice(batchIdx, 0, recycleBtn)

      } else {

        this.buttonList.push(recycleBtn)

      }

    }

    if (!this.buttonList.some(b => b.Func === 'handleBatchManage')) {

      this.buttonList.push({ name: '批次管理', Func: 'handleBatchManage', id: 1000 })

    }

  }

}

</script>



<style scoped>
.batch-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}

.batch-stat {
  margin-right: 10px;
  color: #606266;
  font-size: 12px;
}

.recycle-count-zero {
  color: #c0c4cc;
}

.recycle-record-stat {
  margin-top: 8px;
  font-size: 13px;
  color: #606266;
}

.recycle-record-stat strong {
  color: var(--btn-primary, #2563eb);
  font-weight: 600;
}

.batch-dialog-table {
  width: 100%;
}

.batch-dialog-table /deep/ .el-table__header-wrapper table,
.batch-dialog-table /deep/ .el-table__body-wrapper table {
  width: 100% !important;
}

.batch-op-row {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.batch-action-divider {
  color: #dcdfe6;
  font-size: 12px;
  margin: 0 2px;
  user-select: none;
}

.batch-op-row /deep/ .batch-action-link.el-button--text {
  color: var(--btn-primary, #2563eb);
  padding: 0 4px;
  font-size: 13px;
  font-weight: 400;
}

.batch-op-row /deep/ .batch-action-link.el-button--text:hover,
.batch-op-row /deep/ .batch-action-link.el-button--text:focus {
  color: #66b1ff;
}

.form-tip {
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
  line-height: 1.4;
}

.op-grid {

  width: 150px;

  display: flex;

  justify-content: space-between;

  align-items: center;

  gap: 10px;

}

.op-grid-single {
  justify-content: center;
}

.op-solid-btn {

  width: 70px;

  height: 24px;

  line-height: 22px;

  padding: 0;

  border: 1px solid #dcdfe6;

  border-radius: 4px;

  color: #606266;

  background: #fff;

  margin: 0 !important;

  transition: none !important;

}

.op-solid-btn:not(.op-danger-btn):not(.op-success-btn):hover,
.op-solid-btn:not(.op-danger-btn):not(.op-success-btn):focus,
.op-solid-btn:not(.op-danger-btn):not(.op-success-btn):active {

  border-color: #dcdfe6;

  color: #606266;

  background: #fff;

  box-shadow: none !important;

  transform: none !important;

}

.op-danger-btn,
.compact-table /deep/ .el-button.op-solid-btn.op-danger-btn {

  border-color: #f56c6c !important;

  color: #f56c6c !important;

}

.op-danger-btn:hover,
.op-danger-btn:focus,
.op-danger-btn:active,
.compact-table /deep/ .el-button.op-solid-btn.op-danger-btn:hover,
.compact-table /deep/ .el-button.op-solid-btn.op-danger-btn:focus,
.compact-table /deep/ .el-button.op-solid-btn.op-danger-btn:active {

  border-color: #f56c6c !important;

  color: #f56c6c !important;

  background: #fff !important;

  box-shadow: none !important;

}

.op-warning-btn {

  border-color: #e6a23c;

  color: #e6a23c;

}

.op-warning-btn:hover,

.op-warning-btn:focus,

.op-warning-btn:active {

  border-color: #e6a23c;

  color: #e6a23c;

  background: #fff;

}

.op-success-btn,
.compact-table /deep/ .el-button.op-solid-btn.op-success-btn {

  border-color: #67c23a !important;

  color: #67c23a !important;

}

.op-success-btn:hover,
.op-success-btn:focus,
.op-success-btn:active,
.compact-table /deep/ .el-button.op-solid-btn.op-success-btn:hover,
.compact-table /deep/ .el-button.op-solid-btn.op-success-btn:focus,
.compact-table /deep/ .el-button.op-solid-btn.op-success-btn:active {

  border-color: #67c23a !important;

  color: #67c23a !important;

  background: #fff !important;

  box-shadow: none !important;

}

.compact-table /deep/ .el-button--mini {
  padding: 0;
  transition: none !important;
}

.compact-table /deep/ td.el-table__cell {
  padding-top: 6px;
  padding-bottom: 6px;
}

.compact-table /deep/ .cell {
  line-height: 20px;
}
</style>
